/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface ICheckoutLoyaltyLabelProps {
    className: string;
    text: string;
    htmlFor: string;
}

/**
 * AddPaymentForm SFC.
 * @param root0
 * @param root0.className
 * @param root0.text
 * @param root0.htmlFor
 * @extends {React.FC<ICheckoutLoyaltyLabelProps>}
 */
const CheckoutLoyaltyLabel: React.FC<ICheckoutLoyaltyLabelProps> = ({ className, text, htmlFor }) => {
    return (
        <label className={className} htmlFor={htmlFor}>
            {text}
        </label>
    );
};

export default CheckoutLoyaltyLabel;
